export default class FittingGroup{
    constructor(code){
        this.code = code;
        this.fittings = [];
        this.highlighted = false;
    }

    addFitting(fitting){
        this.fittings.push(fitting);
    }

    highlight(){
        this.highlighted = true;
    }
    
    removeHighlight(){
        this.highlighted = false;
    }

    /**
     * gets first fitting
     */
    getFitting(){
        return this.fittings[0];
    }

    getFieldQuantity(field){
        let quantity = 0;
        this.fittings.forEach(fitting => {
            if(fitting.field == field){
                quantity += fitting.quantity;
            }
        });
        return quantity > 0 ? quantity : "";
    }
}